import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './TATActionType';
import * as actions from './TATAction';
import * as services from './TATServices';

function* fetchTATDataSaga(action) {
    try {
        const response = yield call(services.getAllTatData, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.fetchTatDataSuccess(response?.values));
    } catch (error) {
        let errorMessage = 'Failed to fetch TAT data.';
        console.error('TAT Data API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchTatDataFailure(errorMessage));
    }
}

export default function* watchTATSaga() {
    yield takeEvery(types.FETCH_TAT_DATA_REQUEST, fetchTATDataSaga);
}